module.exports = flarum.core.compat['models/Post'];